export const CFG = {
  // visuals / grid
  cellPx: 18,
  fontSize: 18,
  fontFamily:
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  bg: "#000000",
  fg: "#f2f2f2",
  fgDim: "rgba(242,242,242,0.55)",

  // gameplay
  maxEnemies: 320,
  maxBullets: 420,
  maxPickups: 80,
  contactDpsBase: 20,

  // pacing
  waveSeconds: 22,
  bossEvery: 5,
};

